const $_documentContainer = document.createElement('template');

$_documentContainer.innerHTML = `<style>
@import url('https://cdn1.parksmedia.wdprapps.disney.com/media/layout/assets/fonts/InspireTWDC/InspireTWDC.css');
</style>`;

document.head.appendChild($_documentContainer.content);
